<template>
  <transition name="announcement-fade">
    <div
      v-if="isVisible"
      class="system-announcement"
      role="alert"
    >
      <div class="system-announcement__body">
        <div class="system-announcement__content">
          <Icon
            value="info"
            :ui="{ icon: 'system-announcement__icon' }"
          />
          <div class="system-announcement__text">
            <div class="system-announcement__title">Важная информация</div>
            <p class="system-announcement__message">
              Уважаемые пользователи! С 14 августа для подсистемы «ЭПК» АИС
              «Субсидии АПК» будет проведена замена сертификата в соответствии с
              актуальными требованиями законодательства (Удостоверяющего центра
              РФ). Для корректного подключения к подсистеме необходимо
              использовать Яндекс Браузер. Ссылка на браузер —
              <a
                :href="links.yandexBrowser"
                target="_blank"
                rel="noopener noreferrer"
              >{{ links.yandexBrowser }}</a>.
              Если вы привыкли работать в других браузерах, то вам необходимо
              установить сертификаты. Для установки сертификата перейдите по
              ссылке —
              <a
                :href="links.gosuslugiCert"
                target="_blank"
                rel="noopener noreferrer"
              >{{ links.gosuslugiCert }}</a>.
              Если вы не установите сертификат или не смените браузер, то при
              входе в подсистему ЭПК будут ошибки.
            </p>
          </div>
        </div>
        <Icon
          value="tiny-close"
          :ui="{ icon: 'system-announcement__close' }"
          @click.prevent="dismiss"
        />
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { Icon } from '~packages/epk-front-shared/ui';

import { CERT_ANNOUNCEMENT_LINKS } from '../lib/constants';
import { useSystemAnnouncement } from '../lib/useSystemAnnouncement';

const links = CERT_ANNOUNCEMENT_LINKS;
const { isVisible, dismiss } = useSystemAnnouncement();
</script>

<style lang="scss" scoped src="./SystemAnnouncementPopup.scss" />
